/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppApprovalsRouteImport } from './routes/_app/approvals'
import { Route as AppMeRouteImport } from './routes/_app/me'
import { Route as AppPayrollRouteImport } from './routes/_app/payroll'
import { Route as AppTeamRouteImport } from './routes/_app/team'
import { Route as DevUiRouteImport } from './routes/dev/ui'
import { Route as AppAdminAuditRouteImport } from './routes/_app/admin/audit'
import { Route as AppAdminPayrollApproversRouteImport } from './routes/_app/admin/payroll-approvers'
import { Route as AppAdminSettingsRouteImport } from './routes/_app/admin/settings'
import { Route as AppAdminUsersRouteImport } from './routes/_app/admin/users'
import { Route as AppEmployeesIndexRouteImport } from './routes/_app/employees/index'
import { Route as AppEmployeesEmployeeIdRouteImport } from './routes/_app/employees/$employeeId'
import { Route as AppEmployeesNewRouteImport } from './routes/_app/employees/new'
import { Route as AppHrApprovalsRouteImport } from './routes/_app/hr/approvals'
import { Route as AppHrAttendanceRouteImport } from './routes/_app/hr/attendance'
import { Route as AppHrDepartmentsRouteImport } from './routes/_app/hr/departments'
import { Route as AppHrExitsRouteImport } from './routes/_app/hr/exits'
import { Route as AppHrHolidaysRouteImport } from './routes/_app/hr/holidays'
import { Route as AppHrLeaveRouteImport } from './routes/_app/hr/leave'
import { Route as AppHrLeavePolicyRouteImport } from './routes/_app/hr/leave-policy'
import { Route as AppHrOrgChartRouteImport } from './routes/_app/hr/org-chart'
import { Route as AppMeAttendanceRouteImport } from './routes/_app/me_.attendance'
import { Route as AppMeLeaveRouteImport } from './routes/_app/me_.leave'
import { Route as AppMePayslipsRouteImport } from './routes/_app/me_.payslips'
import { Route as AppMeSalaryRouteImport } from './routes/_app/me_.salary'
import { Route as AppPayrollReportsRouteImport } from './routes/_app/payroll_.reports'
import { Route as AppPayrollRunsRouteImport } from './routes/_app/payroll_.runs'
import { Route as AppPayrollStandingRouteImport } from './routes/_app/payroll_.standing'
import { Route as AppTeamEmployeeIdRouteImport } from './routes/_app/team_.$employeeId'
import { Route as AppTeamAttendanceRouteImport } from './routes/_app/team_.attendance'
import { Route as AppTeamLeaveRouteImport } from './routes/_app/team_.leave'
import { Route as AppHrAttendanceDevicesRouteImport } from './routes/_app/hr/attendance_.devices'
import { Route as AppHrAttendanceFlagsRouteImport } from './routes/_app/hr/attendance_.flags'
import { Route as AppHrAttendanceOfficesRouteImport } from './routes/_app/hr/attendance_.offices'
import { Route as AppPayrollRunsRunIdRouteImport } from './routes/_app/payroll_.runs_.$runId'
import { Route as AppPayrollRunsNewRouteImport } from './routes/_app/payroll_.runs_.new'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppApprovalsRoute = AppApprovalsRouteImport.update({
  id: '/approvals',
  path: '/approvals',
  getParentRoute: () => AppRoute,
} as any)
const AppMeRoute = AppMeRouteImport.update({
  id: '/me',
  path: '/me',
  getParentRoute: () => AppRoute,
} as any)
const AppPayrollRoute = AppPayrollRouteImport.update({
  id: '/payroll',
  path: '/payroll',
  getParentRoute: () => AppRoute,
} as any)
const AppTeamRoute = AppTeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => AppRoute,
} as any)
const DevUiRoute = DevUiRouteImport.update({
  id: '/dev/ui',
  path: '/dev/ui',
  getParentRoute: () => rootRouteImport,
} as any)
const AppAdminAuditRoute = AppAdminAuditRouteImport.update({
  id: '/admin/audit',
  path: '/admin/audit',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminPayrollApproversRoute =
  AppAdminPayrollApproversRouteImport.update({
    id: '/admin/payroll-approvers',
    path: '/admin/payroll-approvers',
    getParentRoute: () => AppRoute,
  } as any)
const AppAdminSettingsRoute = AppAdminSettingsRouteImport.update({
  id: '/admin/settings',
  path: '/admin/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminUsersRoute = AppAdminUsersRouteImport.update({
  id: '/admin/users',
  path: '/admin/users',
  getParentRoute: () => AppRoute,
} as any)
const AppEmployeesIndexRoute = AppEmployeesIndexRouteImport.update({
  id: '/employees/',
  path: '/employees/',
  getParentRoute: () => AppRoute,
} as any)
const AppEmployeesEmployeeIdRoute = AppEmployeesEmployeeIdRouteImport.update({
  id: '/employees/$employeeId',
  path: '/employees/$employeeId',
  getParentRoute: () => AppRoute,
} as any)
const AppEmployeesNewRoute = AppEmployeesNewRouteImport.update({
  id: '/employees/new',
  path: '/employees/new',
  getParentRoute: () => AppRoute,
} as any)
const AppHrApprovalsRoute = AppHrApprovalsRouteImport.update({
  id: '/hr/approvals',
  path: '/hr/approvals',
  getParentRoute: () => AppRoute,
} as any)
const AppHrAttendanceRoute = AppHrAttendanceRouteImport.update({
  id: '/hr/attendance',
  path: '/hr/attendance',
  getParentRoute: () => AppRoute,
} as any)
const AppHrDepartmentsRoute = AppHrDepartmentsRouteImport.update({
  id: '/hr/departments',
  path: '/hr/departments',
  getParentRoute: () => AppRoute,
} as any)
const AppHrExitsRoute = AppHrExitsRouteImport.update({
  id: '/hr/exits',
  path: '/hr/exits',
  getParentRoute: () => AppRoute,
} as any)
const AppHrHolidaysRoute = AppHrHolidaysRouteImport.update({
  id: '/hr/holidays',
  path: '/hr/holidays',
  getParentRoute: () => AppRoute,
} as any)
const AppHrLeaveRoute = AppHrLeaveRouteImport.update({
  id: '/hr/leave',
  path: '/hr/leave',
  getParentRoute: () => AppRoute,
} as any)
const AppHrLeavePolicyRoute = AppHrLeavePolicyRouteImport.update({
  id: '/hr/leave-policy',
  path: '/hr/leave-policy',
  getParentRoute: () => AppRoute,
} as any)
const AppHrOrgChartRoute = AppHrOrgChartRouteImport.update({
  id: '/hr/org-chart',
  path: '/hr/org-chart',
  getParentRoute: () => AppRoute,
} as any)
const AppMeAttendanceRoute = AppMeAttendanceRouteImport.update({
  id: '/me_/attendance',
  path: '/me/attendance',
  getParentRoute: () => AppRoute,
} as any)
const AppMeLeaveRoute = AppMeLeaveRouteImport.update({
  id: '/me_/leave',
  path: '/me/leave',
  getParentRoute: () => AppRoute,
} as any)
const AppMePayslipsRoute = AppMePayslipsRouteImport.update({
  id: '/me_/payslips',
  path: '/me/payslips',
  getParentRoute: () => AppRoute,
} as any)
const AppMeSalaryRoute = AppMeSalaryRouteImport.update({
  id: '/me_/salary',
  path: '/me/salary',
  getParentRoute: () => AppRoute,
} as any)
const AppPayrollReportsRoute = AppPayrollReportsRouteImport.update({
  id: '/payroll_/reports',
  path: '/payroll/reports',
  getParentRoute: () => AppRoute,
} as any)
const AppPayrollRunsRoute = AppPayrollRunsRouteImport.update({
  id: '/payroll_/runs',
  path: '/payroll/runs',
  getParentRoute: () => AppRoute,
} as any)
const AppPayrollStandingRoute = AppPayrollStandingRouteImport.update({
  id: '/payroll_/standing',
  path: '/payroll/standing',
  getParentRoute: () => AppRoute,
} as any)
const AppTeamEmployeeIdRoute = AppTeamEmployeeIdRouteImport.update({
  id: '/team_/$employeeId',
  path: '/team/$employeeId',
  getParentRoute: () => AppRoute,
} as any)
const AppTeamAttendanceRoute = AppTeamAttendanceRouteImport.update({
  id: '/team_/attendance',
  path: '/team/attendance',
  getParentRoute: () => AppRoute,
} as any)
const AppTeamLeaveRoute = AppTeamLeaveRouteImport.update({
  id: '/team_/leave',
  path: '/team/leave',
  getParentRoute: () => AppRoute,
} as any)
const AppHrAttendanceDevicesRoute = AppHrAttendanceDevicesRouteImport.update({
  id: '/hr/attendance_/devices',
  path: '/hr/attendance/devices',
  getParentRoute: () => AppRoute,
} as any)
const AppHrAttendanceFlagsRoute = AppHrAttendanceFlagsRouteImport.update({
  id: '/hr/attendance_/flags',
  path: '/hr/attendance/flags',
  getParentRoute: () => AppRoute,
} as any)
const AppHrAttendanceOfficesRoute = AppHrAttendanceOfficesRouteImport.update({
  id: '/hr/attendance_/offices',
  path: '/hr/attendance/offices',
  getParentRoute: () => AppRoute,
} as any)
const AppPayrollRunsRunIdRoute = AppPayrollRunsRunIdRouteImport.update({
  id: '/payroll_/runs_/$runId',
  path: '/payroll/runs/$runId',
  getParentRoute: () => AppRoute,
} as any)
const AppPayrollRunsNewRoute = AppPayrollRunsNewRouteImport.update({
  id: '/payroll_/runs_/new',
  path: '/payroll/runs/new',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/login': typeof LoginRoute
  '/approvals': typeof AppApprovalsRoute
  '/me': typeof AppMeRoute
  '/payroll': typeof AppPayrollRoute
  '/team': typeof AppTeamRoute
  '/dev/ui': typeof DevUiRoute
  '/admin/audit': typeof AppAdminAuditRoute
  '/admin/payroll-approvers': typeof AppAdminPayrollApproversRoute
  '/admin/settings': typeof AppAdminSettingsRoute
  '/admin/users': typeof AppAdminUsersRoute
  '/employees/$employeeId': typeof AppEmployeesEmployeeIdRoute
  '/employees/new': typeof AppEmployeesNewRoute
  '/hr/approvals': typeof AppHrApprovalsRoute
  '/hr/attendance': typeof AppHrAttendanceRoute
  '/hr/departments': typeof AppHrDepartmentsRoute
  '/hr/exits': typeof AppHrExitsRoute
  '/hr/holidays': typeof AppHrHolidaysRoute
  '/hr/leave': typeof AppHrLeaveRoute
  '/hr/leave-policy': typeof AppHrLeavePolicyRoute
  '/hr/org-chart': typeof AppHrOrgChartRoute
  '/me/attendance': typeof AppMeAttendanceRoute
  '/me/leave': typeof AppMeLeaveRoute
  '/me/payslips': typeof AppMePayslipsRoute
  '/me/salary': typeof AppMeSalaryRoute
  '/payroll/reports': typeof AppPayrollReportsRoute
  '/payroll/runs': typeof AppPayrollRunsRoute
  '/payroll/standing': typeof AppPayrollStandingRoute
  '/team/$employeeId': typeof AppTeamEmployeeIdRoute
  '/team/attendance': typeof AppTeamAttendanceRoute
  '/team/leave': typeof AppTeamLeaveRoute
  '/employees/': typeof AppEmployeesIndexRoute
  '/hr/attendance/devices': typeof AppHrAttendanceDevicesRoute
  '/hr/attendance/flags': typeof AppHrAttendanceFlagsRoute
  '/hr/attendance/offices': typeof AppHrAttendanceOfficesRoute
  '/payroll/runs/$runId': typeof AppPayrollRunsRunIdRoute
  '/payroll/runs/new': typeof AppPayrollRunsNewRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/approvals': typeof AppApprovalsRoute
  '/me': typeof AppMeRoute
  '/payroll': typeof AppPayrollRoute
  '/team': typeof AppTeamRoute
  '/dev/ui': typeof DevUiRoute
  '/': typeof AppIndexRoute
  '/admin/audit': typeof AppAdminAuditRoute
  '/admin/payroll-approvers': typeof AppAdminPayrollApproversRoute
  '/admin/settings': typeof AppAdminSettingsRoute
  '/admin/users': typeof AppAdminUsersRoute
  '/employees/$employeeId': typeof AppEmployeesEmployeeIdRoute
  '/employees/new': typeof AppEmployeesNewRoute
  '/hr/approvals': typeof AppHrApprovalsRoute
  '/hr/attendance': typeof AppHrAttendanceRoute
  '/hr/departments': typeof AppHrDepartmentsRoute
  '/hr/exits': typeof AppHrExitsRoute
  '/hr/holidays': typeof AppHrHolidaysRoute
  '/hr/leave': typeof AppHrLeaveRoute
  '/hr/leave-policy': typeof AppHrLeavePolicyRoute
  '/hr/org-chart': typeof AppHrOrgChartRoute
  '/me/attendance': typeof AppMeAttendanceRoute
  '/me/leave': typeof AppMeLeaveRoute
  '/me/payslips': typeof AppMePayslipsRoute
  '/me/salary': typeof AppMeSalaryRoute
  '/payroll/reports': typeof AppPayrollReportsRoute
  '/payroll/runs': typeof AppPayrollRunsRoute
  '/payroll/standing': typeof AppPayrollStandingRoute
  '/team/$employeeId': typeof AppTeamEmployeeIdRoute
  '/team/attendance': typeof AppTeamAttendanceRoute
  '/team/leave': typeof AppTeamLeaveRoute
  '/employees': typeof AppEmployeesIndexRoute
  '/hr/attendance/devices': typeof AppHrAttendanceDevicesRoute
  '/hr/attendance/flags': typeof AppHrAttendanceFlagsRoute
  '/hr/attendance/offices': typeof AppHrAttendanceOfficesRoute
  '/payroll/runs/$runId': typeof AppPayrollRunsRunIdRoute
  '/payroll/runs/new': typeof AppPayrollRunsNewRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/_app/approvals': typeof AppApprovalsRoute
  '/_app/me': typeof AppMeRoute
  '/_app/payroll': typeof AppPayrollRoute
  '/_app/team': typeof AppTeamRoute
  '/dev/ui': typeof DevUiRoute
  '/_app/': typeof AppIndexRoute
  '/_app/admin/audit': typeof AppAdminAuditRoute
  '/_app/admin/payroll-approvers': typeof AppAdminPayrollApproversRoute
  '/_app/admin/settings': typeof AppAdminSettingsRoute
  '/_app/admin/users': typeof AppAdminUsersRoute
  '/_app/employees/$employeeId': typeof AppEmployeesEmployeeIdRoute
  '/_app/employees/new': typeof AppEmployeesNewRoute
  '/_app/hr/approvals': typeof AppHrApprovalsRoute
  '/_app/hr/attendance': typeof AppHrAttendanceRoute
  '/_app/hr/departments': typeof AppHrDepartmentsRoute
  '/_app/hr/exits': typeof AppHrExitsRoute
  '/_app/hr/holidays': typeof AppHrHolidaysRoute
  '/_app/hr/leave': typeof AppHrLeaveRoute
  '/_app/hr/leave-policy': typeof AppHrLeavePolicyRoute
  '/_app/hr/org-chart': typeof AppHrOrgChartRoute
  '/_app/me_/attendance': typeof AppMeAttendanceRoute
  '/_app/me_/leave': typeof AppMeLeaveRoute
  '/_app/me_/payslips': typeof AppMePayslipsRoute
  '/_app/me_/salary': typeof AppMeSalaryRoute
  '/_app/payroll_/reports': typeof AppPayrollReportsRoute
  '/_app/payroll_/runs': typeof AppPayrollRunsRoute
  '/_app/payroll_/standing': typeof AppPayrollStandingRoute
  '/_app/team_/$employeeId': typeof AppTeamEmployeeIdRoute
  '/_app/team_/attendance': typeof AppTeamAttendanceRoute
  '/_app/team_/leave': typeof AppTeamLeaveRoute
  '/_app/employees/': typeof AppEmployeesIndexRoute
  '/_app/hr/attendance_/devices': typeof AppHrAttendanceDevicesRoute
  '/_app/hr/attendance_/flags': typeof AppHrAttendanceFlagsRoute
  '/_app/hr/attendance_/offices': typeof AppHrAttendanceOfficesRoute
  '/_app/payroll_/runs_/$runId': typeof AppPayrollRunsRunIdRoute
  '/_app/payroll_/runs_/new': typeof AppPayrollRunsNewRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/approvals'
    | '/me'
    | '/payroll'
    | '/team'
    | '/dev/ui'
    | '/admin/audit'
    | '/admin/payroll-approvers'
    | '/admin/settings'
    | '/admin/users'
    | '/employees/$employeeId'
    | '/employees/new'
    | '/hr/approvals'
    | '/hr/attendance'
    | '/hr/departments'
    | '/hr/exits'
    | '/hr/holidays'
    | '/hr/leave'
    | '/hr/leave-policy'
    | '/hr/org-chart'
    | '/me/attendance'
    | '/me/leave'
    | '/me/payslips'
    | '/me/salary'
    | '/payroll/reports'
    | '/payroll/runs'
    | '/payroll/standing'
    | '/team/$employeeId'
    | '/team/attendance'
    | '/team/leave'
    | '/employees/'
    | '/hr/attendance/devices'
    | '/hr/attendance/flags'
    | '/hr/attendance/offices'
    | '/payroll/runs/$runId'
    | '/payroll/runs/new'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/approvals'
    | '/me'
    | '/payroll'
    | '/team'
    | '/dev/ui'
    | '/'
    | '/admin/audit'
    | '/admin/payroll-approvers'
    | '/admin/settings'
    | '/admin/users'
    | '/employees/$employeeId'
    | '/employees/new'
    | '/hr/approvals'
    | '/hr/attendance'
    | '/hr/departments'
    | '/hr/exits'
    | '/hr/holidays'
    | '/hr/leave'
    | '/hr/leave-policy'
    | '/hr/org-chart'
    | '/me/attendance'
    | '/me/leave'
    | '/me/payslips'
    | '/me/salary'
    | '/payroll/reports'
    | '/payroll/runs'
    | '/payroll/standing'
    | '/team/$employeeId'
    | '/team/attendance'
    | '/team/leave'
    | '/employees'
    | '/hr/attendance/devices'
    | '/hr/attendance/flags'
    | '/hr/attendance/offices'
    | '/payroll/runs/$runId'
    | '/payroll/runs/new'
  id:
    | '__root__'
    | '/_app'
    | '/login'
    | '/_app/approvals'
    | '/_app/me'
    | '/_app/payroll'
    | '/_app/team'
    | '/dev/ui'
    | '/_app/'
    | '/_app/admin/audit'
    | '/_app/admin/payroll-approvers'
    | '/_app/admin/settings'
    | '/_app/admin/users'
    | '/_app/employees/$employeeId'
    | '/_app/employees/new'
    | '/_app/hr/approvals'
    | '/_app/hr/attendance'
    | '/_app/hr/departments'
    | '/_app/hr/exits'
    | '/_app/hr/holidays'
    | '/_app/hr/leave'
    | '/_app/hr/leave-policy'
    | '/_app/hr/org-chart'
    | '/_app/me_/attendance'
    | '/_app/me_/leave'
    | '/_app/me_/payslips'
    | '/_app/me_/salary'
    | '/_app/payroll_/reports'
    | '/_app/payroll_/runs'
    | '/_app/payroll_/standing'
    | '/_app/team_/$employeeId'
    | '/_app/team_/attendance'
    | '/_app/team_/leave'
    | '/_app/employees/'
    | '/_app/hr/attendance_/devices'
    | '/_app/hr/attendance_/flags'
    | '/_app/hr/attendance_/offices'
    | '/_app/payroll_/runs_/$runId'
    | '/_app/payroll_/runs_/new'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  LoginRoute: typeof LoginRoute
  DevUiRoute: typeof DevUiRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/approvals': {
      id: '/_app/approvals'
      path: '/approvals'
      fullPath: '/approvals'
      preLoaderRoute: typeof AppApprovalsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/me': {
      id: '/_app/me'
      path: '/me'
      fullPath: '/me'
      preLoaderRoute: typeof AppMeRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/payroll': {
      id: '/_app/payroll'
      path: '/payroll'
      fullPath: '/payroll'
      preLoaderRoute: typeof AppPayrollRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/team': {
      id: '/_app/team'
      path: '/team'
      fullPath: '/team'
      preLoaderRoute: typeof AppTeamRouteImport
      parentRoute: typeof AppRoute
    }
    '/dev/ui': {
      id: '/dev/ui'
      path: '/dev/ui'
      fullPath: '/dev/ui'
      preLoaderRoute: typeof DevUiRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/admin/audit': {
      id: '/_app/admin/audit'
      path: '/admin/audit'
      fullPath: '/admin/audit'
      preLoaderRoute: typeof AppAdminAuditRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/payroll-approvers': {
      id: '/_app/admin/payroll-approvers'
      path: '/admin/payroll-approvers'
      fullPath: '/admin/payroll-approvers'
      preLoaderRoute: typeof AppAdminPayrollApproversRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/settings': {
      id: '/_app/admin/settings'
      path: '/admin/settings'
      fullPath: '/admin/settings'
      preLoaderRoute: typeof AppAdminSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/users': {
      id: '/_app/admin/users'
      path: '/admin/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AppAdminUsersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/employees/': {
      id: '/_app/employees/'
      path: '/employees'
      fullPath: '/employees/'
      preLoaderRoute: typeof AppEmployeesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/employees/$employeeId': {
      id: '/_app/employees/$employeeId'
      path: '/employees/$employeeId'
      fullPath: '/employees/$employeeId'
      preLoaderRoute: typeof AppEmployeesEmployeeIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/employees/new': {
      id: '/_app/employees/new'
      path: '/employees/new'
      fullPath: '/employees/new'
      preLoaderRoute: typeof AppEmployeesNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/hr/approvals': {
      id: '/_app/hr/approvals'
      path: '/hr/approvals'
      fullPath: '/hr/approvals'
      preLoaderRoute: typeof AppHrApprovalsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/hr/attendance': {
      id: '/_app/hr/attendance'
      path: '/hr/attendance'
      fullPath: '/hr/attendance'
      preLoaderRoute: typeof AppHrAttendanceRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/hr/departments': {
      id: '/_app/hr/departments'
      path: '/hr/departments'
      fullPath: '/hr/departments'
      preLoaderRoute: typeof AppHrDepartmentsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/hr/exits': {
      id: '/_app/hr/exits'
      path: '/hr/exits'
      fullPath: '/hr/exits'
      preLoaderRoute: typeof AppHrExitsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/hr/holidays': {
      id: '/_app/hr/holidays'
      path: '/hr/holidays'
      fullPath: '/hr/holidays'
      preLoaderRoute: typeof AppHrHolidaysRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/hr/leave': {
      id: '/_app/hr/leave'
      path: '/hr/leave'
      fullPath: '/hr/leave'
      preLoaderRoute: typeof AppHrLeaveRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/hr/leave-policy': {
      id: '/_app/hr/leave-policy'
      path: '/hr/leave-policy'
      fullPath: '/hr/leave-policy'
      preLoaderRoute: typeof AppHrLeavePolicyRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/hr/org-chart': {
      id: '/_app/hr/org-chart'
      path: '/hr/org-chart'
      fullPath: '/hr/org-chart'
      preLoaderRoute: typeof AppHrOrgChartRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/me_/attendance': {
      id: '/_app/me_/attendance'
      path: '/me/attendance'
      fullPath: '/me/attendance'
      preLoaderRoute: typeof AppMeAttendanceRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/me_/leave': {
      id: '/_app/me_/leave'
      path: '/me/leave'
      fullPath: '/me/leave'
      preLoaderRoute: typeof AppMeLeaveRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/me_/payslips': {
      id: '/_app/me_/payslips'
      path: '/me/payslips'
      fullPath: '/me/payslips'
      preLoaderRoute: typeof AppMePayslipsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/me_/salary': {
      id: '/_app/me_/salary'
      path: '/me/salary'
      fullPath: '/me/salary'
      preLoaderRoute: typeof AppMeSalaryRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/payroll_/reports': {
      id: '/_app/payroll_/reports'
      path: '/payroll/reports'
      fullPath: '/payroll/reports'
      preLoaderRoute: typeof AppPayrollReportsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/payroll_/runs': {
      id: '/_app/payroll_/runs'
      path: '/payroll/runs'
      fullPath: '/payroll/runs'
      preLoaderRoute: typeof AppPayrollRunsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/payroll_/standing': {
      id: '/_app/payroll_/standing'
      path: '/payroll/standing'
      fullPath: '/payroll/standing'
      preLoaderRoute: typeof AppPayrollStandingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/team_/$employeeId': {
      id: '/_app/team_/$employeeId'
      path: '/team/$employeeId'
      fullPath: '/team/$employeeId'
      preLoaderRoute: typeof AppTeamEmployeeIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/team_/attendance': {
      id: '/_app/team_/attendance'
      path: '/team/attendance'
      fullPath: '/team/attendance'
      preLoaderRoute: typeof AppTeamAttendanceRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/team_/leave': {
      id: '/_app/team_/leave'
      path: '/team/leave'
      fullPath: '/team/leave'
      preLoaderRoute: typeof AppTeamLeaveRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/hr/attendance_/devices': {
      id: '/_app/hr/attendance_/devices'
      path: '/hr/attendance/devices'
      fullPath: '/hr/attendance/devices'
      preLoaderRoute: typeof AppHrAttendanceDevicesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/hr/attendance_/flags': {
      id: '/_app/hr/attendance_/flags'
      path: '/hr/attendance/flags'
      fullPath: '/hr/attendance/flags'
      preLoaderRoute: typeof AppHrAttendanceFlagsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/hr/attendance_/offices': {
      id: '/_app/hr/attendance_/offices'
      path: '/hr/attendance/offices'
      fullPath: '/hr/attendance/offices'
      preLoaderRoute: typeof AppHrAttendanceOfficesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/payroll_/runs_/$runId': {
      id: '/_app/payroll_/runs_/$runId'
      path: '/payroll/runs/$runId'
      fullPath: '/payroll/runs/$runId'
      preLoaderRoute: typeof AppPayrollRunsRunIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/payroll_/runs_/new': {
      id: '/_app/payroll_/runs_/new'
      path: '/payroll/runs/new'
      fullPath: '/payroll/runs/new'
      preLoaderRoute: typeof AppPayrollRunsNewRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppApprovalsRoute: typeof AppApprovalsRoute
  AppMeRoute: typeof AppMeRoute
  AppPayrollRoute: typeof AppPayrollRoute
  AppTeamRoute: typeof AppTeamRoute
  AppIndexRoute: typeof AppIndexRoute
  AppAdminAuditRoute: typeof AppAdminAuditRoute
  AppAdminPayrollApproversRoute: typeof AppAdminPayrollApproversRoute
  AppAdminSettingsRoute: typeof AppAdminSettingsRoute
  AppAdminUsersRoute: typeof AppAdminUsersRoute
  AppEmployeesEmployeeIdRoute: typeof AppEmployeesEmployeeIdRoute
  AppEmployeesNewRoute: typeof AppEmployeesNewRoute
  AppHrApprovalsRoute: typeof AppHrApprovalsRoute
  AppHrAttendanceRoute: typeof AppHrAttendanceRoute
  AppHrDepartmentsRoute: typeof AppHrDepartmentsRoute
  AppHrExitsRoute: typeof AppHrExitsRoute
  AppHrHolidaysRoute: typeof AppHrHolidaysRoute
  AppHrLeaveRoute: typeof AppHrLeaveRoute
  AppHrLeavePolicyRoute: typeof AppHrLeavePolicyRoute
  AppHrOrgChartRoute: typeof AppHrOrgChartRoute
  AppMeAttendanceRoute: typeof AppMeAttendanceRoute
  AppMeLeaveRoute: typeof AppMeLeaveRoute
  AppMePayslipsRoute: typeof AppMePayslipsRoute
  AppMeSalaryRoute: typeof AppMeSalaryRoute
  AppPayrollReportsRoute: typeof AppPayrollReportsRoute
  AppPayrollRunsRoute: typeof AppPayrollRunsRoute
  AppPayrollStandingRoute: typeof AppPayrollStandingRoute
  AppTeamEmployeeIdRoute: typeof AppTeamEmployeeIdRoute
  AppTeamAttendanceRoute: typeof AppTeamAttendanceRoute
  AppTeamLeaveRoute: typeof AppTeamLeaveRoute
  AppEmployeesIndexRoute: typeof AppEmployeesIndexRoute
  AppHrAttendanceDevicesRoute: typeof AppHrAttendanceDevicesRoute
  AppHrAttendanceFlagsRoute: typeof AppHrAttendanceFlagsRoute
  AppHrAttendanceOfficesRoute: typeof AppHrAttendanceOfficesRoute
  AppPayrollRunsRunIdRoute: typeof AppPayrollRunsRunIdRoute
  AppPayrollRunsNewRoute: typeof AppPayrollRunsNewRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppApprovalsRoute: AppApprovalsRoute,
  AppMeRoute: AppMeRoute,
  AppPayrollRoute: AppPayrollRoute,
  AppTeamRoute: AppTeamRoute,
  AppIndexRoute: AppIndexRoute,
  AppAdminAuditRoute: AppAdminAuditRoute,
  AppAdminPayrollApproversRoute: AppAdminPayrollApproversRoute,
  AppAdminSettingsRoute: AppAdminSettingsRoute,
  AppAdminUsersRoute: AppAdminUsersRoute,
  AppEmployeesEmployeeIdRoute: AppEmployeesEmployeeIdRoute,
  AppEmployeesNewRoute: AppEmployeesNewRoute,
  AppHrApprovalsRoute: AppHrApprovalsRoute,
  AppHrAttendanceRoute: AppHrAttendanceRoute,
  AppHrDepartmentsRoute: AppHrDepartmentsRoute,
  AppHrExitsRoute: AppHrExitsRoute,
  AppHrHolidaysRoute: AppHrHolidaysRoute,
  AppHrLeaveRoute: AppHrLeaveRoute,
  AppHrLeavePolicyRoute: AppHrLeavePolicyRoute,
  AppHrOrgChartRoute: AppHrOrgChartRoute,
  AppMeAttendanceRoute: AppMeAttendanceRoute,
  AppMeLeaveRoute: AppMeLeaveRoute,
  AppMePayslipsRoute: AppMePayslipsRoute,
  AppMeSalaryRoute: AppMeSalaryRoute,
  AppPayrollReportsRoute: AppPayrollReportsRoute,
  AppPayrollRunsRoute: AppPayrollRunsRoute,
  AppPayrollStandingRoute: AppPayrollStandingRoute,
  AppTeamEmployeeIdRoute: AppTeamEmployeeIdRoute,
  AppTeamAttendanceRoute: AppTeamAttendanceRoute,
  AppTeamLeaveRoute: AppTeamLeaveRoute,
  AppEmployeesIndexRoute: AppEmployeesIndexRoute,
  AppHrAttendanceDevicesRoute: AppHrAttendanceDevicesRoute,
  AppHrAttendanceFlagsRoute: AppHrAttendanceFlagsRoute,
  AppHrAttendanceOfficesRoute: AppHrAttendanceOfficesRoute,
  AppPayrollRunsRunIdRoute: AppPayrollRunsRunIdRoute,
  AppPayrollRunsNewRoute: AppPayrollRunsNewRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
  DevUiRoute: DevUiRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
